import React from "react";

const About = () => {
  return (
    <section className="px-10 py-8 animate-fade-in">
      <div className="max-w-4xl">
        <h1 className="text-center font-bold text-2xl lg:pt-20 lg:text-left text-gradient-primary">
          Halo, Saya Fadli
        </h1>
        <div className="w-24 h-1 bg-gradient-accent rounded-full mx-auto lg:mx-0 mt-3 mb-6"></div>
        <article className="space-y-4">
          <p className="text-justify text-base leading-relaxed indent-8 text-slate-700">
            Sebagai Middle Frontend Developer di <b>Badan Teknologi, Informasi, dan Intelijen Keuangan (BaTii)</b>, saya mengkhususkan diri dalam pengembangan aplikasi web berskala nasional. Dengan keahlian mendalam pada Angular, Tailwind CSS, dan TypeScript, saya mentransformasi proses bisnis yang kompleks menjadi antarmuka yang terukur, intuitif, dan inklusif.
          </p>
          <p className="text-justify text-base leading-relaxed indent-8 text-slate-700">
            Portofolio saya mencakup kontribusi strategis pada ekosistem digital <b>Kementerian Keuangan</b>, termasuk pengembangan sistem <b>Rekrutmen CPNS (CASN)</b> dan <b>SPMB PKN STAN</b> yang melayani jutaan pengguna. Saya juga berperan aktif dalam digitalisasi manajemen pendidikan dan perpustakaan melalui pengembangan solusi perangkat lunak yang andal.
          </p>
          <p className="text-justify text-base leading-relaxed indent-8 text-slate-700">
            Didorong oleh semangat inovasi layanan publik, saya menerapkan standar <i>clean code</i>, optimasi performa, dan kolaborasi tim yang efektif. Fokus utama saya adalah menghadirkan teknologi yang tidak hanya menuntaskan kebutuhan teknis, tetapi juga menciptakan dampak positif yang berkelanjutan bagi transformasi digital pemerintahan.
          </p>
        </article>
      </div>
    </section>
  );
}

export default About;